module.exports = __webpack_public_path__ + "static/media/woman_02.f92ff7f2.png";